import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import { WidgetConfig } from "../../../class/widget-config";
import * as HSET from "./settings";
import { GenericUtils } from './../../../utilities/generic-utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: 'widget-waterfall-chart',
  templateUrl: './widget-waterfall-chart.component.html',
  styleUrls: ['./widget-waterfall-chart.component.scss']
})
export class WidgetWaterfallChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  loadingChart = false;
  errorLoadingChart = false;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private utils: GenericUtils
  ) { }

  ngOnChanges(changes: SimpleChanges) {
      this.getData();
  }

  ngOnInit() {

  }

  getData() {
    const params = {};
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;

    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, this.FILTERS).pipe(takeUntil(this.unsubscribe)).subscribe(
      chart => {

        this.loadingChart = false;
        if (chart) {
          this.chartOptions = this.dataService.createChart(chart, this.CHARTCONFIG);
        } else {
          this.handleError("ERROR_MSG.NO_DATA");
        }
      },
      error => {
        this.loadingChart = false;
        this.handleError("ERROR_MSG.SYSTEM_ERROR");
      }
    );
  }
  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chartData, width: 12 }];
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
